import React, { useState, useCallback, useEffect } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import services from '../services';


import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import IconButton from '@material-ui/core/IconButton';

import MessageModal from '../../../UI/Modal/MessageModal';
import { truncate } from "lodash";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,
    },
    title: {
        fontSize: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    card: {
        alignContent: 'center'
    },
    table: {
        minWidth: 650,
    },
}));



const EditTag = (props) => {

    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [customer, setCustomer] = useState([]);
    const [isCustomerEdit, setIsCustomerEdit] = useState(false);
    const [isDateEdit, setIsDateEdit] = useState(false);
    const [editPermissions, setEditPermissions] = useState({
        isCustomerEdit: false,
        isDateEdit: false,
        isDeductionEdit: false,
        isWeightEdit: false
    });
    const [activeFilter, setActiveFilter] = useState({
        groupID: "",
        operationEntityID: "",
        tag: "",
        date: ""
    });
    const [deductionTypes, setDeductionType] = useState([]);


    const [tagDetails, setTagDetails] = useState({
        routeCode: "",
        date: "",
        cardNo: "",
        supplierRegNo: "",
        grossWeight: "",
        routeName: "",
        newDate: "",
        customerNo: "",
        deductions: "",
        actualAmount: "",
        netAmount: "",
    });
    const [deletedFromOld, setDeletedFromOld] = useState([]);
    const [oldDeductions, setOldDeductions] = useState([]);
    const [newDeductions, setNewDeductions] = useState([]);
    const [deductionFeilds, setDeductionFeild] = useState({
        deductionTypeID: "0",
        deductionAmount: ""
    });

    const [deductionArrays, setDeductionArrays] = useState({
        deletedFromOld:[],
        oldDeductions:[],
        newDeductions:[]
    });

    const [newDate, setNewDate] = useState([]);

    const [customerInfo, setCustomerInfo] = useState({
        customerID: 0,
        cardNumber: "",
        customerNumber: ""
    });

    const [weightAttributes, setWeightAttibutes] = useState({
        totalWeight: "",
        grossWeight: "",
        netWeight: ""
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })


    useEffect(() => {
        if (props.collectionPointID != "") {
            getCustomers(props.collectionPointID);
        }
    }, [props.collectionPointID]);

    useEffect(() => {
        if (props.tagDetails != null) {
            setTagDetails(props.tagDetails);
            setNewDate(props.tagDetails.date);
        }
    }, [props.tagDetails]);

    useEffect(() => {
        setCustomerDefault();
        setDefaultWeightInfo();
    }, [tagDetails]);

    useEffect(() => {
        if (props.activeFilter != null) {
            setActiveFilter(props.activeFilter);
        }
    }, [props.activeFilter]);

    useEffect(() => {
        if (props.oldDeductions != null) {
            setDeductionArrays({
                ...deductionArrays,
                oldDeductions:props.oldDeductions,
            })
        }
    }, [props.oldDeductions]);

 

    useEffect(() => {
        if (activeFilter.operationEntityID != null) {
            getDeductionTypes();
        }
    }, [props.activeFilter]);

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function setDefaultWeightInfo() {
        setWeightAttibutes({
            ...weightAttributes,
            totalWeight: tagDetails.actualAmount,
            grossWeight: tagDetails.grossWeight,
            netWeight: tagDetails.netAmount
        })
    }

    async function setCustomerDefault() {
        setCustomerInfo({
            ...customerInfo,
            cardNumber: tagDetails.cardNo,
            customerNumber: tagDetails.customerNo,
        });
    }
    async function getDeductionTypes() {
        let res = await services.getDeductionTypes();
        console.log("resd", res);
        setDeductionType(res);
    }

    function renderTypesDropDown(data) {
        let items = []
        if (data != null) {
            data.map((item) => {
                items.push(<MenuItem key={item.deductionTypeID} value={item.deductionTypeID}>{item.deductionTypeName}</MenuItem>)
            })

        }
        return items;
    }

    async function getCustomers(collectionPointID) {
        let result = await services.getCustomersFromCollectionPoint(collectionPointID);
        // console.log("dat", result);
        setCustomer(result);
    }

    async function handleSwitchCustomerChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isCustomerEdit

        });
        await setCustomerDefault();
    }
    async function handleSwitchDateChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isDateEdit
        });
    }

    async function handleSwitchWeightChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isWeightEdit
        });
        await setDefaultWeightInfo();
    }

    async function handleSwitchDeductionChange(e) {
        setEditPermissions({
            ...editPermissions,
            [e.target.name]: !editPermissions.isDeductionEdit,
            isWeightEdit:!editPermissions.isDeductionEdit
        });
        if (!e.target.value) {
            setNewDeductions([]);
            setDeductionArrays({
                ...deductionArrays,
                oldDeductions:props.oldDeductions,
            })
        }
      
    }

    function handleSelectedRegNo(e) {
        console.log("drdr", e);
        setCustomerInfo({
            cardNumber: e.cardNumber,
            customerNumber: e.customerRegistrationNumber,
            customerID: e.customerID
        })
    }
    async function handleDeductionFeildChange(e) {
        setDeductionFeild({
            ...deductionFeilds,
            [e.target.name]: e.target.value

        });
    }

    async function handleWeightInfoChange(e) {
        setWeightAttibutes({
            ...weightAttributes,
            [e.target.name]: e.target.value

        });

    }

    async function handleDeleteOldRecord (item){
        
        var dataArray =[];
        dataArray = deductionArrays.oldDeductions;
        var index = dataArray.findIndex(x => x.deductionTemplateID ===item.deductionTemplateID);
        dataArray.splice(index,1);

        

        var deletedArray = [];
        deletedArray = deductionArrays.deletedFromOld;
        deletedArray.push(item);
        
        setDeductionArrays({
            ...deductionArrays,
            oldDeductions:dataArray,
            deletedFromOld:deletedArray
        })
        //await CalculateWeighment(); 
      }
    async function handleDeleteNewRecord(id){
        console.log("found itx",id);
        var dataArray =[];
        dataArray = deductionArrays.newDeductions;
        var index = dataArray.findIndex(x => x.deductionTemplateID ===id);
        dataArray.splice(index,1);
         setDeductionArrays({
             ...deductionArrays,
            newDeductions:dataArray
         });
      }
    async function saveToNewDeductionList(e) {
        let listarray = [];
        listarray = deductionArrays.newDeductions;

        let obj = deductionTypes.find(o => o.deductionTypeID === deductionFeilds.deductionTypeID);

        let form = {
            deductionTypeID: parseInt(deductionFeilds.deductionTypeID),
            deductionAmount: parseFloat(deductionFeilds.deductionAmount),
            deductionTypeName : obj.deductionTypeName
        }

        listarray.push(form);
        setDeductionArrays({
            ...deductionArrays,
           newDeductions:listarray
        });
    }

      function renderNewDeductions(data) {
        let items = [];
        if (data != null) {

            data.map((item) => {
                items.push(
                    <TableRow key={item.deductionTemplateID}>
                        <TableCell component="th" align="center" scope="row">
                            {item.deductionTypeName}
                        </TableCell>
                        <TableCell align="center">{item.deductionAmount}</TableCell>
                        <TableCell align="center">
                            <IconButton aria-label="delete"
                            onClick={(item)=>handleDeleteNewRecord(item.deductionTemplateID)}
                              className={classes.margin}>
                                <Icon>deleteForeverIcon </Icon>
                            </IconButton>
                        </TableCell>

                    </TableRow>
                )
            })

        }
        return items;
    }


    async function handleDateChange(e) {
        setNewDate(e.value);
    }

    async function handleSubmitApproval(){
        var totDeductions =   CalculateWeighment();
        console.log("gross",(Math.round(parseFloat(weightAttributes.totalWeight) )));
        console.log("totalWeight",parseFloat(weightAttributes.totalWeight));
        console.log("net",(parseFloat(weightAttributes.totalWeight)-(totDeductions)));
        console.log("totDeductions", CalculateWeighment());
        let newLeafAmendRequest = {
            operationEntityID: parseInt(activeFilter.operationEntityID),
            tagNumber: activeFilter.tag,
            collectionPointID : props.collectionPointID,
            customerID: customerInfo.customerID,
            cardNumber: customerInfo.cardNumber,
            grossAmount: (Math.round(parseFloat(weightAttributes.totalWeight) )),
            actualAmount:parseFloat(weightAttributes.totalWeight) ,
            netAmount: (parseFloat(weightAttributes.totalWeight)-(totDeductions)),
            totalDeduction: totDeductions,
            newDate: newDate,
            deletedDeduction : deductionArrays.deletedFromOld,
            newDeduction :deductionArrays.newDeductions,
            oldDeduction :deductionArrays.oldDeductions
        }

        let formData={
            isCustomerChanged:editPermissions.isCustomerEdit,
            isDateChanged :editPermissions.isDateEdit,
           
            isWeightChanged :editPermissions.isWeightEdit,
            isDeductionChanged :editPermissions.isDeductionEdit,
            userID :1,
            previoseDate:tagDetails.date,
            oldCollectionRequest :props.prevTagInfo,
            newCollectionRequest :newLeafAmendRequest
        }
     
        var response =  await services.saveToApproval(formData);
        console.log("sttts", response);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function CalculateWeighment(){

        var totalDeduction = 0;
        deductionArrays.oldDeductions.map((row) => {
            totalDeduction= totalDeduction +parseFloat(row.deductionAmount);
        });

        deductionArrays.oldDeductions.map((row) => {
            totalDeduction= totalDeduction + parseFloat(row.deductionAmount);
        });

        return totalDeduction;
    }
 
    return (
        <div hidden={!props.isEdit}>
            <Card >
                <CardContent>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <TextField
                                        id="routeCode"
                                        name="routeCode"
                                        variant="outlined"
                                        size='small'
                                        disabled={true}
                                        fullWidth
                                        label="Route Code *"
                                        //onChange={(e) => handleTagChange(e.target)}
                                        value={tagDetails.routeCode}

                                    >
                                    </TextField>
                                    {/* {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>} */}
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="routeName"
                                        name="tag"
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        disabled={true}
                                        label="Route Name *"
                                        // onChange={(e) => handleTagChange(e.target)}
                                        value={tagDetails.routeName}

                                    >
                                    </TextField>
                                    {/* {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>} */}
                                </Grid>


                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Divider absolute={true} orientation="vertical" variant="middle" />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>
                              
                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isCustomerEdit}
                                        onChange={(event) => handleSwitchCustomerChange(event)}
                                        name="isCustomerEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Customer" />
                                </Grid>
                            </Grid>
                            <div hidden={!editPermissions.isCustomerEdit}>
                                <Grid container spacing={3} >
                                    <Grid item xs={4} >
                                        <Autocomplete
                                            fullWidth
                                            id="combo-box-demo"
                                            size='small'
                                            disabled={!editPermissions.isCustomerEdit}
                                            options={customer}
                                            getOptionLabel={(option) => option.customerRegistrationNumber + "-" + option.customerName}
                                            onChange={(event, value) => handleSelectedRegNo(value)}
                                            renderInput={(params) => <TextField {...params} label="Registration NO" variant="outlined" />}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <TextField
                                        id="CardNo"
                                        name="CardNo"
                                        disabled={true}
                                        variant="outlined"
                                        size='small'
                                        value={customerInfo.cardNumber}
                                        fullWidth
                                        label="Card No*"
                                    >
                                    </TextField>
                                    
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="Customer Number"
                                        name="Customer"
                                        disabled={true}
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        value={customerInfo.customerNumber}
                                        label="Customer Number *" >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>

                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isDateEdit}
                                        onChange={(event) => handleSwitchDateChange(event)}
                                        name="isDateEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Date" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>

                                <Grid item xs={3}>
                                    <TextField
                                        id="newDate"
                                        name="newDate"
                                        variant="outlined"
                                        size='small'
                                        disabled={!editPermissions.isDateEdit}
                                        fullWidth
                                        type='date'
                                        label="Date*"
                                        onChange={(e) => handleDateChange(e.target)}
                                        value={newDate}

                                    >
                                    </TextField>
                                   
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isWeightEdit}
                                        onChange={(event) => handleSwitchWeightChange(event)}
                                        name="isWeightEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Weight" />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <TextField
                                        id="totalWeight"
                                        name="totalWeight"
                                        variant="outlined"
                                        disabled={!editPermissions.isWeightEdit}
                                        size='small'
                                        fullWidth
                                        label="Total Weight *"
                                        onChange={(e) => handleWeightInfoChange(e)}
                                        value={weightAttributes.totalWeight}

                                    >
                                    </TextField>
                                   
                                </Grid>
                               
                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <Card className={classes.root} variant="outlined">
                        <CardContent>
                            <Grid container spacing={3}>

                                <Grid item xs={1} justify="flex-end">
                                    <Switch
                                        color="primary"
                                        label="Edit"
                                        checked={editPermissions.isDeductionEdit}
                                        onChange={(event) => handleSwitchDeductionChange(event)}
                                        name="isDeductionEdit"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>
                                <Grid item xs={2} justify="flex-start">
                                    <Chip label="Edit Deductions" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>

                                <Grid item xs={3}>
                                    <TextField
                                        id="deductionTypeID"
                                        name="deductionTypeID"
                                        select
                                        disabled={!editPermissions.isDeductionEdit}
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        label="Deduction Type"
                                        onChange={(e) => handleDeductionFeildChange(e)}
                                        value={deductionFeilds.deductionTypeID}
                                    >
                                        <MenuItem value="0">--Select Deduction Type--</MenuItem>
                                        {renderTypesDropDown(deductionTypes)}
                                    </TextField>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        id="deductionAmount"
                                        name="deductionAmount"
                                        disabled={!editPermissions.isDeductionEdit}
                                        variant="outlined"
                                        size='small'
                                        fullWidth
                                        label="Deduction Value"
                                        onChange={(e) => handleDeductionFeildChange(e)}
                                        value={deductionFeilds.deductionAmount}

                                    >
                                    </TextField>
                                </Grid>
                                <Grid item xs={3} justify="flex-end">
                                    <Button
                                        onClick={() => saveToNewDeductionList()}
                                        variant="contained"
                                        disabled={!editPermissions.isDeductionEdit}
                                        className={classes.btnroot}
                                        endIcon={<Icon>saveAltIcon </Icon>}

                                    >Add
                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid disabled={!editPermissions.isDeductionEdit} item xs={8}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Deduction Name</TableCell>
                                                    <TableCell align="center">Value</TableCell>
                                                    <TableCell align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                 
                                                 {deductionArrays.oldDeductions.map((row) => (
                                                    <TableRow key={row.deductionTemplateID}>
                                                        <TableCell align="center" component="th" scope="row">
                                                            {row.deductionTypeName}
                                                        </TableCell>
                                                        <TableCell align="center">{row.deductionAmount}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton aria-label="delete"
                                                              onClick={()=>handleDeleteOldRecord(row)}
                                                              className={classes.margin}> 
                                                                <Icon>deleteForeverIcon </Icon>
                                                            </IconButton>
                                                        </TableCell>

                                                    </TableRow>
                                                ))} 
                                            

                                                {renderNewDeductions(deductionArrays.newDeductions)}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                </CardContent>

                <CardActions className={classes.card} alignContent={'right'}>
                    <Grid container justify="flex-end">
                        <Button
                             onClick={() => handleSubmitApproval()}
                            variant="contained"
                            className={classes.btnroot}
                        > Update</Button>&nbsp;
                                       </Grid>

                </CardActions>
            </Card>


            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

        </div>
    );

}
export default EditTag;
